import React from 'react';
import LinkedInAdPreview from './LinkedInAdPreviewj';

const LinkedInAdsetForm = ({ dataItem = {}, onChange, type }) => {
    return (
        <div className='row mt-2 p-2' style={{ minHeight: "260px" }}>
            <div className='col-7 border-end pr-4'>
                <div className='row g-3'>
                    <div className='col-12'>
                        <label className="fw-semibold text-secondary small mb-1" htmlFor='text'>Text *</label>
                        <textarea
                            name='text'
                            placeholder='Enter Post Description Text'
                            rows={4}
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.text}
                            onChange={onChange}
                        />
                    </div>
                    <div className='col-12 mt-3'>
                        <label className="fw-semibold text-secondary small mb-1" htmlFor='landingPageUrl'>Landing Page URL *</label>
                        <input
                            name='landingPageUrl'
                            placeholder='Enter Landing Page URL'
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.landingPageUrl}
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
            <div className='col-5 pl-4 d-flex align-items-start justify-content-center'>
                <div className="w-100">
                    <LinkedInAdPreview type={type} dataItem={dataItem} />
                </div>
            </div>
        </div>
    )
}

export default LinkedInAdsetForm;
